const HtmlContainer = (props: { html: string | TrustedHTML }) => {
  const { html } = props
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  )
}

export default HtmlContainer
